import { render, staticRenderFns } from "./dsLimitationUse.vue?vue&type=template&id=1e6395be&scoped=true"
import script from "./dsLimitationUse.vue?vue&type=script&lang=js"
export * from "./dsLimitationUse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e6395be",
  null
  
)

export default component.exports